import React from 'react';
import ReactDOM from 'react-dom';
import FocusTrap from 'focus-trap-react';

import {
  KEY_CODES
} from '~constants'

import Icon from '~components/icon/icon.component'

import useDocumentEvent from '~common/use-document-event.hook';
import useStyles from './modal.styles';

const Modal = ({ children, props, isShowing, hide, title }) => {
  const classes = useStyles(props);

  /**
   * Set menu inactive if 'ESC' key is pressed.
   * The Macbook Pro touch bar and other touch devices
   * do not register 'keypress' events reliably. Use the
   * 'keydown' event.
   */
  const keyEvent = useDocumentEvent({ eventName: 'keydown' });
  const isKey = KEY => keyEvent && keyEvent.keyCode === KEY_CODES[KEY];

  if (isShowing && isKey('ESC')) {
    hide()
  }

  return isShowing ? 
  ReactDOM.createPortal(
    <>
    <div
      aria-label="Overlay"
      className={classes.modalOverlay}
      onClick={hide}
      onKeyDown={event => {
        if (event.keyCode === KEY_CODES.ENTER) {
          hide()
        }}
      }
      tabIndex={0}
      role="button"
    />
    <div className={classes.modalWrapper} aria-modal aria-hidden tabIndex={-1} role="dialog">
      {/* Prevent focus from leaving modal while its visible */}
      <FocusTrap>
        <div className={classes.modal}>
          <div className={classes.modalHeader}>
            <div className={classes.modalTitle}>
              {title}
            </div>
            <div
              className={classes.modalCloseButton}
              data-dismiss="modal"
              aria-label="Close"
              onClick={hide}
              onKeyDown={event => {
                if (event.keyCode === KEY_CODES.ENTER) {
                  hide(event);
                }}
              }
              tabIndex={0}
              role="button"
            >
              <span aria-hidden="true">
                <Icon name="close" size={14} />
              </span>
            </div>
          </div>
          <div className={classes.modalBody}>
            {children}
          </div>
        </div>
      </FocusTrap>
    </div>
    </>
  , document.body
) : null };

export default Modal;